const api = {
    hqyzmkey: '/login/hqyzmkey', //获取图片验证码
    createtpyzm: '/login/createtpyzm', //获取图片验证码
    dologin: '/login/dologin',  //后台登录
    genggaimima: '/guanliyuan/genggaimima',  //总管理员修改密码
    
    addtimu: '/wenjuan/addtimu',  //添加题目
    timulist: '/wenjuan/timulist', //题目列表
    edittimu: '/wenjuan/edittimu', //题目编辑
    deltimu: '/wenjuan/deltimu', //删除题目

    addwenjuan: '/wenjuan/addwenjuan', //创建问卷
    wenjuanlist: '/wenjuan/wenjuanlist', //问卷列表
    getwjinfo: '/wenjuan/getwjinfo', //问卷详情
    editwenjuan: '/wenjuan/editwenjuan', //编辑问卷
    delwenjuan: '/wenjuan/delwenjuan', //删除问卷
    wjdcxxtongji: '/wenjuan/wjdcxxtongji', //问卷统计
    wenjuantmlist: '/wenjuan/wenjuantmlist', //问卷统计 -> 题目列表
    timudcxxtj: '/wenjuan/timudcxxtj', //题目统计
    daochuwjdcjlexcel: '/wenjuan/daochuwjdcjlexcel', //导出excel
    xiazaitupianzip: '/wenjuan/xiazaitupianzip', //下载图片


    dshwenjuanlist: '/shenhe/dshwenjuanlist', //待审核列表
    yshwjlist: '/shenhe/yshwjlist', //已审核列表
    getwjshinfo: '/shenhe/getwjinfo', //获取问卷详情
    shenhewenjuan: '/shenhe/shenhewenjuan', //审核

    wjdiaochajllist: '/wenjuan/wjdiaochajllist', //调查记录列表
    wjdiaochainfo: '/wenjuan/wjdiaochainfo', //调查记录详情

    addbmdw: '/index/addbmdw', //添加单位
    bmdwlist: '/index/bmdwlist', //单位列表
    editbmdw: '/index/editbmdw', //编辑单位
    delbmdw: '/index/delbmdw', //删除单位

    //反馈工单列表
    fankuilist: '/fankui/fankuilist', //反馈列表
    getfkwtinfo: '/fankui/getfkwtinfo', //获取详情
    editfkwt: '/fankui/editfkwt', //提交反馈

    
}


export default api